import {inject} from '@angular/core'
import {Observable, of} from 'rxjs'
import {WINDOW} from './injection-tokens'

export const isOnInternalDomain = (): Observable<boolean> => {
  return of(inject(WINDOW).location.hostname.includes('internal'))
}
